module.exports = __webpack_public_path__ + "static/media/calendar.476173c5.png";